import React from "react";
import {
  faChartPie,
  faUsers,
  faChalkboardTeacher,
  faBook,
  faCog,
  faChartLine
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";

export const PrincipalMenuItems = ({ NavItem }) => {
  return (
    <>
      <NavItem
        title="Dashboard"
        link={Routes.DashboardOverview.path}
        icon={faChartPie}
      />

      <Dropdown.Divider className="my-3 border-indigo" />

      <NavItem
        title="Turmas"
        link={Routes.Classes.path}
        icon={faUsers}
      />

      <NavItem
        title="Professores"
        link={Routes.Teachers.path}
        icon={faChalkboardTeacher}
      />

      <NavItem
        title="Disciplinas"
        link={Routes.Subjects.path}
        icon={faBook}
      />

      <NavItem
        title="Configurações da Escola"
        link={Routes.SchoolSettings.path}
        icon={faCog}
      />

      {/* <Dropdown.Divider className="my-3 border-indigo" />

      <NavItem
        title="Relatórios"
        link="#"
        icon={faChartLine}
      /> */}
    </>
  );
};

export default PrincipalMenuItems;
